<template lang="pug">
  #section2
    #s2s1.group
      .background.block
        .capside-side.text-center
          img(src="/assets/img/chapter1/covid1.png")
          img(src="/assets/img/chapter1/covid2.png")
        .title.text-center
          h2.py-0.uppercase.light Y ¿qué son los 
            br
            span.bolder.accent-yellow-text coronavirus en específico?
      #s2s1t1.block
        .fake-header
        .slide
          p Los coronavirus son una familia de virus que están envueltos por una capa hecha de grasas que pueden infectar animales con columna vertebral. Adentro contienen una sola cadena de RNA positivo. El RNA positivo es el que está listo para ser expresado por la célula del huésped. Además, los coronavirus tienen incrustados picos de proteínas, haciéndolos parecer una corona cuando son vistos por medio de un microscopio electrónico.  
        .fake-footer
      #s2s1t2.block
        .fake-header
        .slide
          p Los diferentes tipos de coronavirus han sido identificados en ratas, caballos, vacas, humanos y algunos otros; y pueden causar enfermedades variadas desde gastroenteritis hasta enfermedades del tracto respiratorio.
        .fake-footer
      #s2s1t3.block
        .fake-header
        .slide
          p Se estima que en humanos hasta el 30% de los resfríos comunes son causados por coronavirus; sin embargo, éstos raramente causan enfermedades del aparato respiratorio inferior (o  sea, en la tráquea y los pulmones). Hasta ahora conocemos siete coronavirus que infectan humanos. 
        .fake-footer
</template>

<script>
export default {
  name: "Section2"
};
</script>
<style lang="scss" scoped>
#section2 {
  margin-top: 80vh;
  min-height: 500vh;
  #s2s1 {
    height: 550vh;
    .block {
      @include blockin(100%, 100%, 0, 0%);
      .title {
        position: sticky;
        top: 40%;
        left: 5%;
        width: 90%;
        margin-bottom: 64%;
      }
      .capside-side {
        position: sticky;
        top: 15%;
        img {
          width: 38%;
          max-width: 333px;
          min-width: 100px;
          margin: 0 5px;
        }
      }
      .slide {
        //height: 50%;
        h2,
        p {
          margin-top: 5rem;
          @include blockinP(90%, 55%, 5%);
          text-align: center;
          max-width: 900px;
          margin-right: auto;
          margin-left: auto;
        }
      }
    }
    #s2s1t1 {
      @include blockin(100%, 34%, 0%, 0%);
      .fake-header {
        @include fakinH(2vh, 0%);
      }
      .fake-footer {
        @include fakinF(3vh, 0%);
      }
    }
    #s2s1t2 {
      @include blockin(100%, 33%, 33%, 0%);
      .fake-header {
        @include fakinH(1vh, -3%);
      }
      .fake-footer {
        @include fakinF(1vh, 3%);
      }
    }
    #s2s1t3 {
      @include blockin(100%, 33%, 67%, 0%);
      .fake-header {
        @include fakinH(1vh, -3%);
      }
      .fake-footer {
        @include fakinF(1vh, 3%);
      }
    }
    svg {
      position: sticky;
      margin-left: -30%;
      top: 69%;
      z-index: -1;
    }
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  #section2 {
    #s2s1 {
      .block {
        .title {
          top: 43%;
        }
      }
    }
  }
}

@media (min-width: 992px) and (max-width: 1399px) {
  #section2 {
    #s2s1 {
      .block {
        .title {
          margin-bottom: 30%;
        }
        .capside-side {
          top: 2%;
          padding-bottom: 5%;
          img {
            max-width: 273px;
          }
        }
      }
      #s2s1t1 {
        .fake-header {
          @include fakinH(2vh, 9%);
        }
      }
      #s2s1t3 {
        .fake-footer {
          @include fakinF(3vh, 9%);
        }
      }
    }
  }
}

// Extra large devices (large desktops, 1400px and up)
@media (min-width: 1400px) {
  #section2 {
    #s2s1 {
      .block {
        .title {
          margin-bottom: 30%;
        }
        .capside-side {
          top: 12%;
          padding-bottom: 15%;
        }
      }
      #s2s1t1 {
        .fake-header {
          @include fakinH(2vh, 9%);
        }
      }
      #s2s1t3 {
        .fake-footer {
          @include fakinF(3vh, 9%);
        }
      }
    }
  }
}
</style>
